export const msalConfig = {
  auth: {
    clientId:    import.meta.env.VITE_AZURE_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    // Prevent MSAL from navigating back to /login after processing the auth
    // code at the redirect URI. Without this, MSAL re-navigates to wherever
    // loginRedirect was called from (the login page), so the user stays on
    // /login even after a successful authentication.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation:          'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Popup-based login: we only need the ID token to identify the user.
// The backend validates the ID token (audience = client ID) and issues its
// own local JWT — we never pass an Azure access token to the API.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
